import './App.css';

import './iteam/containers/IteamContainer';
import IteamContainer from './iteam/containers/IteamContainer';

function App() {
  return (
    <div className="App">
      <IteamContainer />
    </div>
  );
}

export default App;
